<zp-analytics />
<zp-billing-notification />

<div class="layout-wrapper">

  <zp-toolbar />

  <div class="layout-main-container">
    <router-outlet />
  </div>

  <p-toast position="top-center" />
  <zp-report-timezone-notification />
</div>
